module.exports = __webpack_public_path__ + "static/media/map_reduced_colour_extended_feather_compressed.55f34bfc.jpg";